import { Tooltip } from '@/components/primitives/Tooltip'
import { form } from '../formState'
import { useTexts } from '../hooks/useTexts'

type Props = {
  disabled?: boolean
  helperText?: string
}

export function CheckinField(props: Props) {
  const texts = useTexts()
  const { disabled: fieldDisabled, helperText } = props
  const {
    meta: { submitting, disabled },
  } = form.useFormMeta()
  const disableField = submitting || disabled || fieldDisabled

  return (
    <form.Checkbox
      label={
        <Tooltip title={texts.requiredTooltip} placement="bottom" disabled={!disableField}>
          <>{texts.checkin}</>
        </Tooltip>
      }
      name="checkIn"
      validateOn="blur"
      disabled={disableField}
      helperText={helperText}
      testId="driver-assistance-form-check-in-field"
    />
  )
}
